<template>
  <div class="process-wrapper">
    <img :src="imgSrc" alt="">
  </div>
</template>
<script>
import processBg from '../../../../assets/images/home/process_bg.png'
import processNotRegisterBg from '../../../../assets/images/home/process_not_register_bg.png'
import processNotRegisterBg2 from '../../../../assets/images/home/process_not_register_bg2.png'

export default {
  name: 'commonProcess',
  components: {
  },
  props: {
    activityInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    moduleName: {
      type: String,
      default: ''
    },
    isShowNum: {
      type: Boolean
    }
  },
  computed: {
    btnInfo() {
      const { apply_status, submit_status, jumpUrl } = this.activityInfo
      return {
        apply_status,
        submit_status,
        jumpUrl
      }
    },
    imgSrc() {
      return this.moduleName === 'notRegistered' ? (this.isShowNum ? processNotRegisterBg2 : processNotRegisterBg) : processBg
    }
  }
}
</script>
